import { Button, Heading, Input, Modal, Text } from '@afterpaytouch/core'
import { useTranslation } from 'next-i18next'
import React, { ChangeEvent, FunctionComponent, useContext } from 'react'
import { useChangeEmailVerifyEmailMutation } from '../../../../state/account/changeEmail'
import { EditEmailAddressModalContext, EditEmailAddressSteps } from '../../EditEmailAddressModal'
import { MaskedElement } from '@afterpaytouch/integrations/MaskedElement'

const I18N_NAMESPACE = ['common', 'account']

export const Edit: FunctionComponent = () => {
  const { t } = useTranslation(I18N_NAMESPACE)
  const { token, setStep, newEmail, setNewEmail } = useContext(EditEmailAddressModalContext)

  const testNameSpace = 'edit-email-address-modal-edit'

  const onEmailInputChange = (e: ChangeEvent<HTMLInputElement>): void => setNewEmail(e.target.value)

  const [verifyEmail, { isError: isVerifyEmailError, isLoading: isVerifyEmailLoading }] = useChangeEmailVerifyEmailMutation()

  const onButtonClick = async (): Promise<void> => {
    try {
      await verifyEmail({
        body: {
          newEmail,
          token,
        },
      }).unwrap()
      setStep(EditEmailAddressSteps.Confirm)
    } catch (err) {}
  }

  const isEmailInputDisabled = isVerifyEmailLoading
  const isButtonDisabled = isVerifyEmailLoading || newEmail.length === 0

  return (
    <>
      <Modal.Header divider>
        <div className='text-center'>
          <Heading testNameSpace={testNameSpace} size='L'>
            {t('account:edit:email:edit:header:heading')}
          </Heading>
        </div>
      </Modal.Header>
      <Modal.Content>
        <div>
          <div className='mt-2'>
            <Text>{t('account:edit:email:edit:content:message')}</Text>
          </div>
          <MaskedElement>
            <div className='mt-4'>
              <Input.Email
                onChange={onEmailInputChange}
                label={t('account:edit:email:edit:content:email-field:placeholder')}
                disabled={isEmailInputDisabled}
                error={isVerifyEmailError}
                errorText={'Some email error'}
                testNameSpace={testNameSpace}
                required
                fullWidth
                autoFocus
              />
            </div>
          </MaskedElement>
          <div className='mt-6'>
            <Button padding='Fluid' disabled={isButtonDisabled} loading={isVerifyEmailLoading} onClick={onButtonClick} testNameSpace={testNameSpace}>
              <Text bold>{t('account:edit:email:edit:content:cta')}</Text>
            </Button>
          </div>
        </div>
      </Modal.Content>
    </>
  )
}
